import { PassInfoModal } from '@/components/Package/PassInfoModal'
import PassSection from '@/components/Package/PassSection'
import useWindowDimensions from '@/lib/web-ui/useWindowDimensions'
import React from 'react'
import { BooksProduct, isBooksProduct } from 'src/api/booksProducts'
import { IProduct } from 'src/api/product'
import { PriceSection } from '../components/PriceSection'
import { ProductDetailContent } from '../components/ProductDetail/ProductDetailContent'
import ProductDetailInfo from '../components/ProductDetail/ProductDetailInfo'
import ProductPreviewModal from '../components/ProductPreviewModal'
import { ProductDetailViewWrapper } from '../styles/ProductDetail.style'

export interface ProductDetailViewProps {
	product: IProduct | BooksProduct
}

export const ProductDetailView: React.FC<ProductDetailViewProps> = ({ product }) => {
	const { width } = useWindowDimensions()
	const productType = isBooksProduct(product) ? product.productType : product.source_type
	const isMobile = width < 768

	return (
		<>
			<ProductDetailViewWrapper>
				<ProductDetailInfo
					product={product}
					priceSection={
						productType === 'handout' ? (
							<PassSection product={product} />
						) : (
							<PriceSection product={product} />
						)
					}
				/>
				<ProductDetailContent
					product={product}
					priceSection={
						productType === 'handout' ? (
							<PassSection product={product} />
						) : (
							<PriceSection product={product} type={'side'} />
						)
					}
				/>
				{!isBooksProduct(product) && !isMobile && <ProductPreviewModal product={product} />}
				<PassInfoModal />
			</ProductDetailViewWrapper>
		</>
	)
}
